import { ViewSupport47Container } from "../../../containers/SupportSystem/ViewReports/ViewSupport47Container"
export function ViewSupport47Page() {
    return (
        <ViewSupport47Container />
    )
}